import type React from 'react';
import TitrationCurve from './TitrationCurve';
import PhScale from './PhScale';
import SolubilityRules from './SolubilityRules';
import GasLaws from './GasLaws';
import Dilution from './Dilution';
import SigFigs from './SigFigs';

// SOLUTIONS / ACIDS-BASES / STATES cluster. Each widget takes a loose `config`
// (resilient to partial data) and an optional `onComplete` fired on first
// interaction. Registered by `type` string for the WidgetRenderer to dispatch.
export const SOLUTIONS_WIDGETS: Record<
  string,
  React.ComponentType<{ config: any; onComplete?: () => void }>
> = {
  titration_curve: TitrationCurve,
  ph_scale: PhScale,
  solubility: SolubilityRules,
  gas_laws: GasLaws,
  dilution: Dilution,
  sig_figs: SigFigs,
};

export { TitrationCurve, PhScale, SolubilityRules, GasLaws, Dilution, SigFigs };
export type { SigFigsConfig } from './SigFigs';
export type { TitrationCurveConfig } from './TitrationCurve';
export type { PhScaleConfig } from './PhScale';
export type { SolubilityConfig } from './SolubilityRules';
export type { GasLawsConfig } from './GasLaws';
export type { DilutionConfig } from './Dilution';
